import { formatBalance } from "../../../lib/utils";

export function ProfitRows({ profitItems }: { profitItems: any }) {
  return (
    <div className="border BookEZ_accordion_border_color BookEZ_card_radius overflow-hidden">
      {profitItems.map((item: any, index: any) => {
        const isLast = index === profitItems.length - 1;
        const isNetProfit = item.name === "Net Profit";
        return (
          <div
            key={item.id}
            className={`${
              isNetProfit
                ? "BookEZ_accordion_net_profit_bg"
                : "BookEZ_accordion_bg"
            } ${!isLast ? "border-b BookEZ_card_border_color" : ""}`}
          >
            <div className="py-3 px-4 flex justify-between BookEZ_font_bold ">
              <div
                className={
                  isNetProfit
                    ? "BookEZ_accordion_net_profit_text_color"
                    : "BookEZ_font_color_gray_2"
                }
              >
                {item.name}
              </div>
              <div
                className={
                  isNetProfit
                    ? "BookEZ_accordion_net_profit_text_color"
                    : "BookEZ_font_color_gray_2"
                }
              >
                {formatBalance(item.balance)}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
